import React from 'react';
import { styles } from '../../styles';

const AmendmentTypeCard = ({ option, onClick }) => {
  return (
    <div
      onClick={() => onClick(option.id)}
      style={styles.card}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#1976d2';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = '#ddd';
        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      }}
    >
      <div style={styles.cardIcon}>
        {option.icon}
      </div>
      <h3 style={styles.cardTitle}>
        {option.title}
      </h3>
      <p style={styles.cardDescription}>
        {option.description}
      </p>
    </div>
  );
};

export default AmendmentTypeCard;
